const TOKEN_KEY = 'talent_admin_token'
const ADMIN_INFO_KEY = 'talent_admin_info'
const PERMISSION_CODES_KEY = 'talent_admin_permission_codes'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token || '')
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getAdminInfo() {
  const raw = localStorage.getItem(ADMIN_INFO_KEY)
  return raw ? JSON.parse(raw) : null
}

export function setAdminInfo(info) {
  localStorage.setItem(ADMIN_INFO_KEY, JSON.stringify(info || {}))
}

export function removeAdminInfo() {
  localStorage.removeItem(ADMIN_INFO_KEY)
}

export function getPermissionCodes() {
  const raw = localStorage.getItem(PERMISSION_CODES_KEY)
  return raw ? JSON.parse(raw) : []
}

export function setPermissionCodes(codes) {
  localStorage.setItem(PERMISSION_CODES_KEY, JSON.stringify(codes || []))
}

export function removePermissionCodes() {
  localStorage.removeItem(PERMISSION_CODES_KEY)
}

export function clearAuth() {
  removeToken()
  removeAdminInfo()
  removePermissionCodes()
}

export function hasPermission(code) {
  const codes = getPermissionCodes()
  return !code || codes.includes(code)
}
